var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isRestricted)?_c('div',[_c('entry-fee')],1):_c('div',[_c('profile-conversation-messages')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }